const sectionCustomSearch = document.querySelector('.custom-search');
const customSearchButton = sectionCustomSearch.querySelector('button');

function createCustomSearchUrl() {

    const customSearchSelects = sectionCustomSearch.querySelectorAll('select');
    
    const params = Array.from(customSearchSelects).map(select => {
    
        let name = select.name;

        if(name == "product_type"){
            name = "filter.p.product_type";
        }else if(name == "usage_type"){
            name = "filter.p.m.custom.usage_type";
        }else if(name == "application_zone"){
            name = "filter.p.m.custom.application_zone";
        }

        const value = select.value;
        return `${name}=${encodeURIComponent(value)}`;
        
    });
    
    const baseUrl = "/collections/produits?";
    const fullUrl = baseUrl + params.join('&');
    
    window.location.href = fullUrl;

}

customSearchButton.addEventListener('click', () => {
    createCustomSearchUrl();
})